import { Component } from "react"
import PropTypes from "prop-types"

import colors from "foundation/_colors_export.scss?export"

export default class ConnectedServicesChart extends Component {
  getSettings(props, Highcharts) {
    const { servicesUrl } = props
    const totalUsers = props.worksWith.reduce((acc, curr) => acc + curr.users_with_enabled_applets, 0)
    const worksWith = props.worksWith.filter(ww => ww.users_with_enabled_applets / totalUsers > 0.01)

    return {
      chart: {
        animation: false,
        renderTo: this.chartContainer,
        type: "pie",
      },
      title: {
        text: this.renderTitle(),
        align: "center",
        verticalAlign: "middle",
        useHTML: true,
        y: 0,
        style: { maxWidth: "120px", whiteSpace: "normal", textAlign: "center" },
      },
      legend: {
        enabled: false,
      },
      credits: {
        enabled: false,
      },
      plotOptions: {
        pie: {
          cursor: "default",
          dataLabels: {
            enabled: true,
            distance: -50,
            formatter() {
              if (this.percentage > 8) {
                return `<img width="30" height="30" src='${this.point.icon}' alt=${this.point.name}></img>`
              }
            },
            useHTML: true,
            inside: true,
            style: {
              color: (Highcharts.theme && Highcharts.theme.contrastTextColor) || colors.primaryTextColor,
            },
          },
        },
        series: {
          animation: false,
          colorByPoint: true,
          events: {
            click(event) {
              if (servicesUrl) {
                window.location.assign(`${servicesUrl}/${event.point.options.moduleName}`)
              }
            },
          },
        },
      },
      tooltip: {
        enabled: true,
        useHTML: true,
        headerFormat: "",
        padding: 0,
        backgroundColor: "#fff",
        borderColor: "#fff",
        pointFormat: `<div class='tooltip'><div class='header' style='background-color: {point.color};'><img src='{point.icon}' alt='{point.name}' width='25' height='25'/>{point.name}</div><div class='row'><p class='stat'>{point.percent}%</p><p>of your connections are to this service</p></div><div class='row'></div></div>`,
      },
      series: [
        {
          name: "Connections",
          colorByPoint: true,
          colors: worksWith.map(ww => "#" + ww.works_with_channel.brand_color),
          innerSize: "50%",
          data: worksWith.map(ww => {
            return {
              y: ww.users_with_enabled_applets,
              name: ww.works_with_channel.name,
              icon: ww.works_with_channel.monochrome_image_url,
              color: `#${ww.works_with_channel.brand_color}`,
              percent: Math.ceil((ww.users_with_enabled_applets / totalUsers) * 100),
              moduleName: ww.works_with_channel.module_name,
            }
          }),
        },
      ],
    }
  }

  async componentDidMount() {
    const Highcharts = await import("highcharts")
    Highcharts.setOptions(window.globalHighchartsOptions)

    this.chart = new Highcharts.Chart(this.getSettings(this.props, Highcharts))
  }

  async shouldComponentUpdate(nextProps) {
    const Highcharts = await import("highcharts")
    Highcharts.setOptions(window.globalHighchartsOptions)

    if (this.props.worksWith !== nextProps.worksWith) {
      this.chart.destroy()
      this.chart = new Highcharts.Chart(this.getSettings(nextProps, Highcharts))
    }
    return false
  }

  componentWillUnmount() {
    this.chart.destroy()
  }

  renderTitle() {
    return `Top services connected`
  }

  render() {
    return <div className="donut-chart" ref={c => (this.chartContainer = c)} />
  }
}

ConnectedServicesChart.propTypes = {
  worksWith: PropTypes.array.isRequired,
  serviceName: PropTypes.string.isRequired,
  servicesUrl: PropTypes.string,
}
